import React from 'react';

interface IconProps {
  width?: number;
  height?: number;
  style?: React.CSSProperties;
}

export const FaceSuspicionIcon: React.FC<IconProps> = ({ width = 32, height = 32, style }) => {
  return (
    <svg width={width} height={height} viewBox="0 0 32 32" fill="none" xmlns="http://www.w3.org/2000/svg" style={style}>
      <path
        d="M15.9989 29.9978C25.3333 29.9978 29.9978 23.7303 29.9978 15.9989C29.9978 8.26751 25.3333 2 15.9989 2C6.66443 2 2 8.26751 2 15.9989C2 23.7303 6.66443 29.9978 15.9989 29.9978Z"
        fill="#FFB02E"
      />
      <path
        d="M10.5 18.25C12.8472 18.25 14.75 16.3472 14.75 14C14.75 11.6528 12.8472 9.75 10.5 9.75C8.15279 9.75 6.25 11.6528 6.25 14C6.25 16.3472 8.15279 18.25 10.5 18.25Z"
        fill="white"
      />
      <path
        d="M21.5 18.25C23.8472 18.25 25.75 16.3472 25.75 14C25.75 11.6528 23.8472 9.75 21.5 9.75C19.1528 9.75 17.25 11.6528 17.25 14C17.25 16.3472 19.1528 18.25 21.5 18.25Z"
        fill="white"
      />
      <path
        d="M23.0558 8.7294C23.0558 8.7294 23.0524 8.72332 23.0483 8.71652C23.0394 8.70186 23.0231 8.67645 22.9985 8.64375C22.9493 8.57812 22.8686 8.48507 22.7503 8.39043C22.52 8.20625 22.1287 8 21.5001 8C20.8716 8 20.4802 8.20625 20.25 8.39043C20.1317 8.48507 20.0509 8.57812 20.0017 8.64375C19.9771 8.67645 19.9608 8.70186 19.9519 8.71652C19.9478 8.72332 19.9444 8.72941 19.9444 8.72941C19.8191 8.97216 19.5216 9.06974 19.2765 8.94721C19.0295 8.82372 18.9294 8.52338 19.0529 8.27639L19.0534 8.2753L19.054 8.27411L19.0554 8.27144L19.0587 8.26499L19.068 8.24781C19.0753 8.23451 19.085 8.21758 19.0971 8.19754C19.1214 8.15751 19.1559 8.1048 19.2017 8.04375C19.2931 7.92188 19.4311 7.76493 19.6253 7.60957C20.02 7.29375 20.6287 7 21.5001 7C22.3716 7 22.9802 7.29375 23.375 7.60957C23.5692 7.76493 23.7071 7.92188 23.7985 8.04375C23.8443 8.1048 23.8788 8.15751 23.9031 8.19754C23.9153 8.21758 23.9249 8.23451 23.9322 8.24781L23.9415 8.26499L23.9448 8.27144L23.9462 8.27411L23.9468 8.2753L23.9473 8.27639C24.0708 8.52338 23.9707 8.82372 23.7237 8.94721C23.4787 9.06974 23.1811 8.97216 23.0558 8.7294Z"
        fill="#402A32"
      />
      <path
        d="M13 14C13 15.1046 12.1046 16 11 16C9.89543 16 9 15.1046 9 14C9 12.8954 9.89543 12 11 12C12.1046 12 13 12.8954 13 14Z"
        fill="#402A32"
      />
      <path
        d="M23 14C23 15.1046 22.1046 16 21 16C19.8954 16 19 15.1046 19 14C19 12.8954 19.8954 12 21 12C22.1046 12 23 12.8954 23 14Z"
        fill="#402A32"
      />
      <path
        d="M8.92264 8.23281C9.02481 8.39434 9.1734 8.58041 9.40747 8.72806C9.63811 8.87355 9.98062 9.00006 10.5001 9.00006C11.0135 9.00006 11.351 8.86893 11.5819 8.71955C11.8188 8.5663 11.9722 8.37572 12.0957 8.20594C12.2582 7.98263 12.5709 7.93328 12.7942 8.09572C13.0175 8.25816 13.0668 8.57087 12.9044 8.79419C12.7577 8.99581 12.5176 9.30524 12.1252 9.55913C11.7268 9.8169 11.1994 10.0001 10.5001 10.0001C9.80675 10.0001 9.2765 9.82777 8.87396 9.57385C8.47483 9.32209 8.2298 9.00816 8.07748 8.76732C7.92988 8.53394 7.99942 8.22509 8.23281 8.07748C8.46619 7.92988 8.77504 7.99942 8.92264 8.23281Z"
        fill="#402A32"
      />
      <path
        d="M12 21C12 20.4477 12.4477 20 13 20H19C19.5523 20 20 20.4477 20 21C20 21.5523 19.5523 22 19 22H13C12.4477 22 12 21.5523 12 21Z"
        fill="#402A32"
      />
    </svg>
  );
};
